import actionTypes from '../actions/app-version.action-types';

export default (state = '', action) => {
  switch (action.type) {
    case actionTypes.FETCH_BE_APP_VERSION_SUCCESS:
      return action.version;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/utils/rw-app-version/reducers/backend-app-version.js